import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { billingGroupApi } from '../../api/lib/billing-group';
import { billingGroupsKeys } from '../../api/query-keys/billing-groups';
import { BillingGroup } from '../../api/types/billing-group';

export const useBillingGroup = (id: number) => {
  return useQuery<BillingGroup, ApiError>({
    queryKey: billingGroupsKeys.detail(id),
    queryFn: () => billingGroupApi.fetchBillingGroup(id),
  });
};
